import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { Form } from '@unform/web';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import * as Yup from 'yup';
import Button from '../../components/Button';
import CancelButton from '../../components/CancelButton';
import FormInput from '../../components/FormInput';
import { formSelectStyles, formSelectControlFullWidth } from '../../components/FormInput/formSelectStyles';
import Api, { exceptionNotificationAPI } from '../../services/api';
import getValidationErrors from '../../utils/getValidationErrors';
import { Container } from './styles';
import { success_message } from '../../components/Toast';
import { AiOutlineDelete } from 'react-icons/ai'
import GetTypeInput from '../../components/FormInput/set';

const SubSectionKPIEdit = () => {
    const { id } = useParams();
    const [unitMeasureOptions, setUnitMeasureOptions] = useState();
    const [kpiOptions, setKpiOptions] = useState();
    const [reportYearOptions, setReportYearOptions] = useState();
    const [companiesOptions, setCompaniesOptions] = useState();
    const [cultureTypeOptions, setCultureTypeOptions] = useState();
    const [fuelTypeOptions, setFuelTypeOptions] = useState();
    const [countriesOptions, setCountriesOptions] = useState();
    const [subSectionKPIsOptions, setSubSectionKPIsOptions] = useState();
    const [listTreeOptions, setListTreeOptions] = useState([]);
    const [customOptions, setCustomOptions] = useState();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [isKPILoading, setIsKPILoading] = useState(true);
    const [KPIsOptions, setKPIsOptions] = useState([]);
    const [selectedReportYearID, setSelectedReportYearID] = useState(0);
    const [selectedKPIID, setSelectedKPIID] = useState(0);
    const [selectedColumnRowID, setSelectedColumnRowID] = useState(0);
    const [columnRowsOptions, setColumnRowsOptions] = useState([]);
    const [selectCustomValue, setSelectCustomValue] = useState([]);
    const [unitMeasureList, setUnitMeasureList] = useState([]);
    const [selectCustomInput, setSelectCustomInput] = useState("");
    const [multipleValues, setMultipleValues] = useState([]);
    const [userObject, setUserObject] = useState(
        JSON.parse(localStorage.getItem('@Thrive:user')),
    );

    const [disabledCustomSelect, setDisabledCustomSelect] = useState(true);
    const formRef = useRef(null);
    const hasFormPopulatedRef = useRef(false);
    const [data, setData] = useState(null);
    const [isFormReady, setIsFormReady] = useState(false);
    const [formDataVersion, setFormDataVersion] = useState(0);

    const booleanOptions = [
        { value: true, text: "Yes" },
        { value: false, text: "No" }
    ];

    const toleranceTypeOptions = [
        { value: 1, text: "Range Type" },
        { value: 2, text: "Greater Than" },
        { value: 3, text: "Lower Than" },
        { value: 4, text: "Equal To" },
        { value: 5, text: "Greater Than or Equal To" },
        { value: 6, text: "Lower Than or Equal To" },
        { value: 7, text: "Custom" },
    ];

    const quantQualOptions = [
        { value: "Quant", text: "Quant" },
        { value: "Qual", text: "Qual" }
    ];

    const inputCalcOptions = [
        { value: "Calculation", text: "Calculation" },
        { value: "Input", text: "Input" },
        { value: "DisplayText", text: "DisplayText" }
    ];

    const EvidenceCalculationMethodOptions = [
        { value: "SUM", text: "SUM" },
        { value: "COUNT", text: "COUNT" },
        { value: "AVG", text: "AVG" }
    ];

    const optionsModeViewOptions = [
        { value: "", text: "None" },
        { value: 1, text: "SelectTree" },
        { value: 2, text: "SelectMultiple" },
        { value: 3, text: "SelectOne" },
    ];

    const evidenceAndDescriptionOptions = [
        { value: "Non-mandatory", text: "Non-mandatory" },
        { value: "Mandatory", text: "Mandatory" }
    ];

    const booleanColors = [
        { value: "", text: "Select a color" },
        { value: "#102a63", text: "Blue Dark" },
        { value: "#004f9f", text: "Blue" },
        { value: "#00b1eb", text: "Blue Twitter" },
        { value: "#ff0000", text: "Red" },
        { value: "#50af47", text: "Green" },
        { value: "#fbba00", text: "Yellow" },
        { value: "#5a328a", text: "Purple Dark" },
        { value: "#f93b94", text: "Pink" }
    ];

    useEffect(() => {
        initializeForm();
    }, [id]);

    // Set form ready after component mounts
    useEffect(() => {
        setIsFormReady(true);
    }, []);

    useEffect(() => {
        if (selectedKPIID && selectedKPIID != 0) {
            Api.get(`SubSectionKPI/getColumnRows?kpiId=${selectedKPIID}`).then((result) => {
                if (result && result.data && result.data.response.length > 0) {
                    const columnRows = result.data.response;
                    const options = columnRows.map(item => ({ value: item.columnRowID, text: item.name }));
                    setColumnRowsOptions(options);
                    if (selectedColumnRowID && selectedColumnRowID != 0) {
                        const el = document.getElementById('columnRowID');
                        if (el) el.value = selectedColumnRowID;
                    }
                } else {
                    setColumnRowsOptions([]);
                }
            }).catch((error) => {
                exceptionNotificationAPI(error);
            });
        } else {
            setColumnRowsOptions([]);
        }
    }, [selectedKPIID]);

    const handleToleranceChange = (form, event) => {
        const toleranceTypeSelect = form?.getFieldRef?.('toleranceType')?.current;
        const lowerToleranceField = form?.getFieldRef?.('lowerTolerance')?.current;
        const upperToleranceField = form?.getFieldRef?.('upperTolerance')?.current;
        const toleranceKPILinkedRefNumberSelect = form?.getFieldRef?.('toleranceKPILinkedRefNumber')?.current;
        const alertMessageField = form?.getFieldRef?.('alertMessage')?.current;
        const toleranceValue = event?.target?.value ?? toleranceTypeSelect?.value;
        if (toleranceValue === undefined) return;
        if (lowerToleranceField) {
            lowerToleranceField.disabled = toleranceValue == 1 ? false : true;
            lowerToleranceField.value = "";
        }
        if (upperToleranceField) {
            upperToleranceField.disabled = toleranceValue == 1 ? false : true;
            upperToleranceField.value = "";
        }
        if (toleranceKPILinkedRefNumberSelect) {
            toleranceKPILinkedRefNumberSelect.disabled = toleranceValue > 1 ? false : true;
            toleranceKPILinkedRefNumberSelect.value = "";
        }
        if (alertMessageField) {
            alertMessageField.disabled = toleranceValue != 0 ? false : true;
            alertMessageField.value = "";
        }
    }

    const handleChangeKPIID = (e, event) => {
        const value = event?.target?.value ?? e?.getFieldRef?.("kpiid")?.current?.value;
        if (value !== undefined && value !== null) setSelectedKPIID(value);
    }

    const handleChangeReportYearID = (e, event) => {
        const value = event?.target?.value ?? e?.getFieldRef?.("reportYearID")?.current?.value;
        if (value !== undefined && value !== null) setSelectedReportYearID(value);
    }

    const handleChangeColumnRowID = (e, event) => {
        const value = event?.target?.value ?? e?.getFieldRef?.("columnRowID")?.current?.value;
        if (value !== undefined && value !== null) setSelectedColumnRowID(value);
    }

    const handleChangeESGOption = (e, event) => {
        const esgoptionSelect = e?.getFieldRef?.('esgOption')?.current;
        const esgrefnumberField = e?.getFieldRef?.('esgRefNumber')?.current;
        if (!esgoptionSelect || !esgrefnumberField) return;

        const esgValue = event?.target?.value ?? esgrefnumberField?.value;
        console.log(esgValue, "aquii")
        esgrefnumberField.disabled = esgValue == "" || esgValue == "simple-sum" ? true : false;
        esgrefnumberField.value = "";
    }

    const ESGOptions = [
        { value: "", text: "Select an option" },
        { value: "simple-sum", text: "Simple sum" },
        { value: "weighted-average-perc", text: "Weighted average %" },
        { value: "weighted-average-no", text: "Weighted average No" }
    ];

    const fields = [
        {
            label: "Report Year",
            name: "reportYearID",
            type: "select",
            options: reportYearOptions,
            onChanged: handleChangeReportYearID
        },
        {
            label: "KPI",
            name: "kpiid",
            type: "select",
            options: kpiOptions,
            onChanged: handleChangeKPIID
        },
        {
            label: "ColumnRow",
            name: "columnRowID",
            type: "select",
            options: columnRowsOptions,
            onChanged: handleChangeColumnRowID
        },
        {
            label: "Is Active",
            name: "isActive",
            type: "select",
            options: booleanOptions,
            required: true,
        },
        {
            label: "Mandatory",
            name: "mandatory",
            type: "select",
            options: booleanOptions,
            required: true,
        },
        {
            label: 'Mandatory Attachments',
            name: 'mandatoryAttachment',
            type: 'select',
            options: booleanOptions,
            required: true,
        },
        {
            label: "Answer Type KPI",
            name: "unitMeasureID",
            type: "select",
            options: unitMeasureOptions,
            placeholder: { value: "", text: "" },
            required: true,
        },
        {
            label: "Ref Number",
            name: "refNumber",
            type: "number",
            required: true,
        },
        {
            label: "Options (custom)",
            name: "customOptions",
            type: "selectcustom",
            required: false,
        },
        {
            label: "Select Answers RefNumber",
            name: "selectAnswersRefNumber",
            type: "textarea",
            required: false,
        },
        {
            label: "Selection from KPI: ListTree options = direct children of ref selection",
            name: "selectionFromKpiListTreeDirectChildren",
            type: "select",
            options: booleanOptions,
            required: false,
        },
        {
            label: "ListTree item attr name (for Calculation from ListTree item)",
            name: "listTreeAttrName",
            type: "input",
            required: false,
        },
        {
            label: "ListTree attr source KPI ref (KPI that selects the ListTree item)",
            name: "listTreeAttrSourceRefNumber",
            type: "input",
            required: false,
        },
        {
            label: "Companies to exclude",
            name: "subSectionKPICompany",
            type: "selectcustom",
            required: false,
            options: companiesOptions,
            multiple: true
        },
        {
            label: "Input/Calculation",
            name: "inputCalc",
            type: "select",
            options: inputCalcOptions,
            required: true,
        },
        {
            label: "Calculation",
            name: "calculation",
            type: "input", //Tem uma validação diferente por que os campos vão estar em linha
            required: false,
        },
        {

            label: "Tolerance Type",
            name: "toleranceType",
            type: "select",
            options: toleranceTypeOptions,
            required: false,
            onChanged: handleToleranceChange,
            placeholder: { value: "0", text: "No tolerance" }
        },
        {
            label: "Lower Tolerance",
            name: "lowerTolerance",
            type: "number",
            disabled: true,
            required: false
        },
        {
            label: "Upper Tolerance",
            name: "upperTolerance",
            type: "number",
            disabled: true,
            required: false
        },
        {
            label: "KPI Linked (Tolerance)",
            name: "toleranceKPILinkedRefNumber",
            type: "input",
            disabled: true,
            required: false
        },
        {
            label: "Alert Message (Tolerance)",
            name: "alertMessage",
            type: "textarea",
            disabled: true,
            required: false
        },
        {
            label: "Input Message",
            name: "inputMessage",
            type: "textarea",
            required: false
        },
        {
            label: "Evidence",
            name: "evidence",
            type: "select",
            options: evidenceAndDescriptionOptions,
            required: false
        },
        {
            label: "Comment",
            name: "comment",
            type: "select",
            options: evidenceAndDescriptionOptions,
            required: false
        },
        {
            label: "Target BAT",
            name: "targetBAT",
            type: "textarea",
            required: false
        },
        {
            label: "Border Color",
            name: "borderColor",
            type: "select",
            options: booleanColors,
            required: false,
        },
        {
            label: "Use value from last year",
            name: "useValueFromLastYear",
            type: "select",
            options: booleanOptions,
            required: true,
        },
        {
            label: "ESG Option",
            name: "esgOption",
            type: "select",
            options: ESGOptions,
            required: false,
            onChanged: handleChangeESGOption
        },
        {
            label: "ESG Ref Number",
            name: "esgRefNumber",
            type: "input",
            required: false,
            disabled: true,
        },
        {
            label: "Evidence RefNumber Validate",
            name: "evidenceRefNumberValidate",
            type: "textarea",
            required: false,
        },
        {
            label: "Evidence Calcllation Method",
            name: "evidenceCalculationMethod",
            type: "select",
            options: EvidenceCalculationMethodOptions,
            required: false
        },
        {
            label: "List tree",
            name: "listTreeID",
            type: "select",
            options: listTreeOptions,
            required: false,
        },
        {
            label: "Options mode (view)",
            name: "optionsModeView",
            type: "select",
            options: optionsModeViewOptions,
            required: false,
        },
        {
            label: "Allow select only children nodes",
            name: "allowSelectOnlyChildrenNodes",
            type: "select",
            options: booleanOptions,
            required: true,
        },
        {
            label: "Max tree depth (empty = no limit)",
            name: "maxTreeDepth",
            type: "number",
            required: false,
            min: 0,
        },
    ]


    const [SubSectionKPIConditionalfields, setSubSectionKPIConditionalfields] = useState([

        {
            label: "Value answer",
            name: "value",
            type: "input",
            required: true
        },
        {
            label: "Sub Section KPI ",
            name: "subSectionKPIID",
            type: "select",
            required: true,
            options: subSectionKPIsOptions,
            multiple: true
        },

    ]);




    const fetchSubSectionKPI = async (subSectionKPIID) => {
        try {
            const result = await Api.get(`subSectionKPI/get?id=${subSectionKPIID}`);
            if (result && result.data) {
                return result.data.response;
            }
            return null;
        } catch (error) {
            exceptionNotificationAPI(error);
            return null;
        }
    }

    /** Obtém valor da API suportando camelCase e PascalCase (ex.: isActive / IsActive). */
    const getApiFieldValue = (obj, fieldName) => {
        if (obj == null) return undefined;
        const v = obj[fieldName];
        if (v !== undefined && v !== null) return v;
        const pascal = fieldName.charAt(0).toUpperCase() + fieldName.slice(1);
        return obj[pascal];
    };

    /**
     * Normaliza customOptions da API para o CreatableSelect.
     * - Produção pode devolver string sem ";" (uma única opção) — antes ia para else e zerava o select.
     * - Aceita array de strings (alguns serializers .NET / JSON).
     */
    const parseCustomOptionsFromApi = (raw) => {
        if (raw === undefined || raw === null) {
            return { multi: [], joined: '' };
        }
        let parts = [];
        if (Array.isArray(raw)) {
            parts = raw
                .map((item) => (item == null ? '' : String(item).trim()))
                .filter((s) => s.length > 0);
        } else if (typeof raw === 'string') {
            const trimmed = raw.trim();
            if (!trimmed) {
                return { multi: [], joined: '' };
            }
            parts = trimmed.includes(';')
                ? trimmed.split(';').map((s) => s.trim()).filter((s) => s.length > 0)
                : [trimmed];
        } else {
            const s = String(raw).trim();
            if (s) parts = [s];
        }
        const multi = parts.map((e) => ({ value: e, label: e }));
        const joined = parts.join(';');
        return { multi, joined };
    };

    const isCustomOptionsUnitMeasure = (unitMeasureID) => {
        const n = Number(unitMeasureID);
        return n === 24 || n === 77;
    };

    /**
     * Constrói o objeto de dados do formulário a partir da resposta da API.
     * Mesmo padrão de antes da migração: chaves em camelCase, valores normalizados.
     * Usado para initialData (quando form ainda não montou) e para setData.
     */
    const buildFormDataFromResponse = (subSectionData) => {
        if (!subSectionData) return null;
        var dataObj = {};
        fields.forEach(f => {
            if (f.name == "sectionCompany" || f.name == "subSectionKPICompany") {
                const arr = getApiFieldValue(subSectionData, f.name);
                if (arr != null && arr.length > 0) {
                    var dataMultiple = arr.map((sc) => ({
                        value: sc.companyID,
                        label: sc.company.name
                    }));
                    setMultipleValues(dataMultiple);
                }
            } else if (f.name == "customOptions") {
                const customOpts = getApiFieldValue(subSectionData, "customOptions");
                const umId = getApiFieldValue(subSectionData, "unitMeasureID");
                const { multi, joined } = parseCustomOptionsFromApi(customOpts);

                setDisabledCustomSelect(!isCustomOptionsUnitMeasure(umId));

                setSelectCustomValue(multi);
                setCustomOptions(joined || (typeof customOpts === 'string' ? customOpts.trim() : '') || undefined);
                dataObj[f.name] = joined;
            } else if (f.name == "reportYearID") {
                const val = getApiFieldValue(subSectionData, f.name);
                dataObj[f.name] = val != null ? val : "";
                setSelectedReportYearID(val);
            } else if (f.name == "kpiid") {
                const val = getApiFieldValue(subSectionData, f.name);
                dataObj[f.name] = val != null ? val : "";
                setSelectedKPIID(val);
            } else if (f.name == "columnRowID") {
                const val = getApiFieldValue(subSectionData, f.name);
                dataObj[f.name] = val != null ? val : "";
                setSelectedColumnRowID(val);
            } else {
                if (f.name.indexOf(".") > -1) {
                    var fragments = f.name.split('.');
                    var object = getObjects(subSectionData, fragments);
                    dataObj[f.name] = (object != null ? object : "");
                } else {
                    const val = getApiFieldValue(subSectionData, f.name);
                    dataObj[f.name] = val !== undefined && val !== null ? val : "";
                }
            }
        });
        dataObj.subSectionKPIConditionalBlocks = getApiFieldValue(subSectionData, 'subSectionKPIConditionalBlocks') ?? [];
        return dataObj;
    };

    const populateForm = (subSectionData) => {
        try {
            if (!formRef.current) {
                return false;
            }
            const dataObj = buildFormDataFromResponse(subSectionData);
            if (!dataObj) return false;

            formRef.current.setData(dataObj);
            setData(dataObj);

            // Set tolerance fields based on tolerance type
            if (dataObj.toleranceType == 1) {
                const lowerToleranceField = formRef.current.getFieldRef('lowerTolerance');
                const upperToleranceField = formRef.current.getFieldRef('upperTolerance');
                if (lowerToleranceField?.current) lowerToleranceField.current.disabled = false;
                if (upperToleranceField?.current) upperToleranceField.current.disabled = false;
            } else if (dataObj.toleranceType > 1) {
                const toleranceKPILinkedRefNumberField = formRef.current.getFieldRef('toleranceKPILinkedRefNumber');
                const alertMessageField = formRef.current.getFieldRef('alertMessage');
                if (toleranceKPILinkedRefNumberField?.current) toleranceKPILinkedRefNumberField.current.disabled = false;
                if (alertMessageField?.current) alertMessageField.current.disabled = false;
            }

            // Set ESG option fields
            if (dataObj.esgOption == "" || dataObj.esgOption == "simple-sum") {
                const esgRefNumberField = formRef.current.getFieldRef('esgRefNumber');
                if (esgRefNumberField?.current) esgRefNumberField.current.disabled = true;
            } else {
                const esgRefNumberField = formRef.current.getFieldRef('esgRefNumber');
                if (esgRefNumberField?.current) esgRefNumberField.current.disabled = false;
            }

            // Conditional blocks: opções do multiselect + unitMeasure do campo "value" (um único setState para não perder um dos dois)
            setSubSectionKPIConditionalfields(prev => {
                let next = prev;
                if (subSectionKPIsOptions && subSectionKPIsOptions.length > 0) {
                    next = next.map((field, idx) =>
                        idx === 1 ? { ...field, options: subSectionKPIsOptions } : field
                    );
                }
                if (unitMeasureList?.length > 0 && dataObj.unitMeasureID) {
                    const unit = unitMeasureList.find(e => e.unitMeasureID == dataObj.unitMeasureID);
                    if (unit) {
                        const typeInput = GetTypeInput(unit.unitMeasureID, unit.type);
                        next = next.map((field, idx) =>
                            idx === 0 ? { ...field, unitMeasure: typeInput } : field
                        );
                    }
                }
                return next;
            });
            return true;
        } catch (error) {
            exceptionNotificationAPI(error);
            return false;
        }
    }

    const initializeForm = async () => {
        try {
            setIsLoading(true);
            hasFormPopulatedRef.current = false;

            // Passo 1: Carregar dados básicos em paralelo
            await Promise.all([
                loadUnitMeasures(),
                loadCompanies(),
                loadCultureType(),
                loadFuelType(),
                loadCountries(),
                loadReportYears(),
                loadListTrees(),
            ]);

            // Passo 2: Se está editando (id existe), buscar dados da SubSectionKPI
            if (id) {
                const subSectionData = await fetchSubSectionKPI(id);

                if (subSectionData) {
                    // Passo 3: Com reportYearID conhecido, carregar KPIs e SubSectionKPIs
                    const reportYearIdForLoad = getApiFieldValue(subSectionData, 'reportYearID');
                    const [, subSectionKPIsOpts] = await Promise.all([
                        loadKPIs(reportYearIdForLoad),
                        loadSubSectionKPIs(reportYearIdForLoad)
                    ]);

                    // Opções do multiselect de Conditional Blocks: populateForm não roda quando o form
                    // já foi preenchido aqui (hasFormPopulatedRef), e o state de options pode atrasar um render.
                    if (subSectionKPIsOpts && subSectionKPIsOpts.length > 0) {
                        setSubSectionKPIConditionalfields(prev =>
                            prev.map((field, idx) =>
                                idx === 1 ? { ...field, options: subSectionKPIsOpts } : field
                            )
                        );
                    }

                    // Passo 4: Com kpiID conhecido, carregar columnRows
                    const kpiId = getApiFieldValue(subSectionData, 'kpiid');
                    if (kpiId) {
                        await loadColumnRows(kpiId);
                    }

                    // Passo 5: Popular o formulário (mesmo padrão de antes da migração)
                    // Se formRef já estiver pronto, setData no form; senão guardar dataObj no state para initialData
                    const dataObj = buildFormDataFromResponse(subSectionData);
                    const formPopulated = formRef.current ? (() => { formRef.current.setData(dataObj); setData(dataObj); return true; })() : false;
                    if (formPopulated) {
                        hasFormPopulatedRef.current = true;
                        setFormDataVersion((v) => v + 1);
                    } else {
                        setData(dataObj);
                    }
                }
            }
        } catch (error) {
            exceptionNotificationAPI(error);
        } finally {
            setIsLoading(false);
        }
    };

    // Effect to populate form when it becomes ready (retry when formRef was null on first load)
    useEffect(() => {
        if (isFormReady && data && formRef.current && !hasFormPopulatedRef.current) {
            const populated = populateForm(data);
            if (populated) {
                hasFormPopulatedRef.current = true;
                setFormDataVersion((v) => v + 1);
            }
        }
    }, [isFormReady, data]);

    // Garante opções no multiselect de Conditional Blocks quando subSectionKPIsOptions chega ao state
    // (ex.: populateForm com timing de render; ou recarregar após mudar report year).
    useEffect(() => {
        if (!subSectionKPIsOptions?.length) return;
        setSubSectionKPIConditionalfields(prev =>
            prev.map((field, idx) =>
                idx === 1 ? { ...field, options: subSectionKPIsOptions } : field
            )
        );
    }, [subSectionKPIsOptions]);

    const loadColumnRows = async (kpiID) => {
        try {
            const result = await Api.get(`SubSectionKPI/getColumnRows?kpiId=${kpiID}`);
            if (result && result.data && result.data.response.length > 0) {
                const columnRows = result.data.response;
                const options = columnRows.map(item => ({ value: item.columnRowID, text: item.name }));
                setColumnRowsOptions(options);
            }
        } catch (error) {
            exceptionNotificationAPI(error);
        }
    }

    const loadCultureType = async () => {
        try {
            const userStoraged = JSON.parse(localStorage.getItem('@Thrive:user'));
            const result = await Api.get(`culture/getAllTypesByCulture?cultureID=${userStoraged.selectedCultureID}`);
            if (result && result.data) {
                const options = result.data.response.map(item => ({ value: item.cultureTypeID, text: item.description, hidden: false }));
                setCultureTypeOptions(options);
            }
        } catch (error) {
            exceptionNotificationAPI(error);
        }
    }
    const loadFuelType = async () => {
        try {
            const result = await Api.get('FuelType/GetAll');
            if (result && result.data) {
                const options = result.data.response.map(item => ({ value: item.fuelTypeID, text: item.name, kpiRefNumber: item.kpiRefNumber, unit: item.unit }));
                setFuelTypeOptions(options);
            }
        } catch (error) {
            exceptionNotificationAPI(error);
        }
    }
    const loadCountries = async () => {
        try {
            const result = await Api.get('Company/getAllCountries');
            if (result && result.data) {
                const options = result.data.response.map(item => ({ value: item.countryID, text: item.name }));
                setCountriesOptions(options);
            }
        } catch (error) {
            exceptionNotificationAPI(error);
        }
    }

    const loadReportYears = async () => {
        try {
            const userLogged = JSON.parse(localStorage.getItem('@Thrive:user'));
            const result = await Api.get(`Culture/getAllReportYearsByCulture?cultureID=${userLogged.selectedCultureID}`);
            if (result && result.data) {
                const options = result.data.response?.reportYears?.map(item => ({ value: item.reportYearID, text: `${item.year}` }));
                setReportYearOptions(options);
            }
        } catch (error) {
            exceptionNotificationAPI(error);
        }
    }

    const loadUnitMeasures = async () => {
        try {
            const result = await Api.get('UnitMeasure/getAll');
            if (result && result.data) {
                setUnitMeasureList(result.data.response);
                const options = result.data.response.map(item => ({ value: item.unitMeasureID, text: item.description + " - " + item.type }));
                setUnitMeasureOptions(options);
            }
        } catch (error) {
            exceptionNotificationAPI(error);
        }
    };

    const loadListTrees = async () => {
        try {
            const result = await Api.get('ListTree/getAll');
            const list = result?.data?.response ?? [];
            setListTreeOptions([
                { value: '', text: 'None' },
                ...list.map(item => ({
                    value: item.listTreeID,
                    text: item.name || `List #${item.listTreeID}`,
                })),
            ]);
        } catch (error) {
            exceptionNotificationAPI(error);
        }
    };

    const loadCompanies = async () => {
        try {
            const cultureID = userObject?.selectedCultureID;
            if (!cultureID) return;
            const result = await Api.get(`Company/getAllByCulture?cultureID=${cultureID}`);
            if (result && result.data) {
                const options = result.data.response.map(item => ({ value: item.companyID, label: `${item.name}` }));
                setCompaniesOptions(options);
            }
        } catch (error) {
            exceptionNotificationAPI(error);
        }
    }

    const getObjects = (currentObject, fragments) => {
        if (fragments.length > 0) {
            var object = currentObject[fragments[0]];

            if (object != null) {
                fragments.shift();
                return getObjects(object, fragments);
            }
            else {
                return "";
            }
        }

        return currentObject;
    }


    const removeRule = (index) => {
        if (!data?.subSectionKPIConditionalBlocks?.[index]) return;
        const blocks = [...data.subSectionKPIConditionalBlocks];
        const block = blocks[index];
        if (block.subSectionKPIConditionalBlockRuleID) {
            blocks[index] = { ...block, isDeleted: true };
        } else {
            blocks.splice(index, 1);
        }
        setData({ ...data, subSectionKPIConditionalBlocks: blocks });
        /*let valueObjectToChange = valuesObject;
        let valuesToChange = valueObjectToChange.find(e => e.columnRowID == column.columnRowID)
        if (valuesToChange) {
            valuesToChange.subSectionKPIConditionalBlocks.splice(colIndex, 1)
            valueObjectToChange[indexToChange] = valuesToChange;
            setValuesObject([...valueObjectToChange])
        }*/

    }

    const loadKPIs = async (reportYearID) => {
        try {
            const result = await Api.get(`KPI/getAllByReportYearID?reportYearID=${reportYearID}`);
            if (result && result.data) {
                const options = result.data.response.map(item => ({ value: item.kpiid, text: item.description }));
                setKpiOptions(options);
                setIsKPILoading(false);
            }
        } catch (error) {
            exceptionNotificationAPI(error);
        }
    }

    const loadSubSectionKPIs = async (reportYearID) => {
        try {
            if (reportYearID == null || reportYearID === '') {
                setSubSectionKPIsOptions([]);
                return [];
            }
            const result = await Api.get(`SubSectionKPI/getAll?reportYearID=${reportYearID}`);
            if (result && result.data) {
                const options = result.data.response.map(item => ({ value: item.subSectionKPIID, label: String(item.refNumber ?? '') }));
                const optionsWithPlaceholder = [{ value: "", label: "Select a SubSection KPI" }, ...options];
                setSubSectionKPIsOptions(optionsWithPlaceholder);
                return optionsWithPlaceholder;
            }
        } catch (error) {
            exceptionNotificationAPI(error);
        }
        return [];
    }

    const setAnswersRules = (value, colIndex, field) => {
        if (!data?.subSectionKPIConditionalBlocks) return;
        const blocks = [...data.subSectionKPIConditionalBlocks];
        if (blocks[colIndex] == null) return;
        blocks[colIndex] = { ...blocks[colIndex], [field]: value };
        setData({ ...data, subSectionKPIConditionalBlocks: blocks });
    }

    const handleSubmit = async (dataForm) => {
        try {
            var obj = {}
            var postObj = {};
            const submitUrl = `subSectionKPI/${(id != null) ? "edit" : "new"}`;

            postObj["subSectionKPIID"] = id;
            postObj["subSectionKPIConditionalBlocks"] = data?.subSectionKPIConditionalBlocks ?? []

            fields.map(f => {
                if (f.required !== undefined && f.required === false) {
                    return null;
                } else {
                    return obj[f.name] = Yup.string().required(`${f.label} is required`);
                }

            })

            const schema = Yup.object().shape(obj);

            await schema.validate(dataForm, {
                abortEarly: false,
            });

            fields.map(f => {
                return postObj[f.name] = dataForm[f.name]
            })

            // FIXO, CUIDAR (CUSTOM OPTIONS)
            if (selectCustomValue.length > 0) {
                postObj.customOptions = selectCustomValue.map((e) => { return e.value }).join(';');
            }

            // FIXO, CUIDAR (SECTION COMPANY)
            if (multipleValues.length > 0) {
                var formColumn = "subSectionKPICompany";
                postObj[formColumn] = multipleValues.map((m) => {
                    var dataForm = {
                        companyID: m.value
                    }
                    return dataForm;
                });
            }

            const toNullableInt = (v) => {
                if (v === '' || v === undefined || v === null) return null;
                const n = Number(v);
                return Number.isNaN(n) ? null : n;
            };
            postObj.listTreeID = toNullableInt(postObj.listTreeID);
            postObj.optionsModeView = toNullableInt(postObj.optionsModeView);
            postObj.maxTreeDepth = toNullableInt(postObj.maxTreeDepth);
            postObj.allowSelectOnlyChildrenNodes =
                postObj.allowSelectOnlyChildrenNodes === true ||
                postObj.allowSelectOnlyChildrenNodes === 'true';
            postObj.selectionFromKpiListTreeDirectChildren =
                postObj.selectionFromKpiListTreeDirectChildren === true ||
                postObj.selectionFromKpiListTreeDirectChildren === 'true';

            await Api.post(submitUrl, postObj);
            navigate(`/subSectionKPI`);
        } catch (error) {
            if (error instanceof Yup.ValidationError) {
                const errors = getValidationErrors(error);
                formRef.current.setErrors(errors);
                return;
            }
            exceptionNotificationAPI(error);
        }
    }

    return (
        !isLoading ?
            <Container className="container">
                <div>
                    <h3>{(id != null) ? "Edit" : "New"} {"subSectionKPI"}</h3>
                    <Form onSubmit={handleSubmit} ref={formRef} initialData={id && data ? data : undefined}>
                        <table className="table table-striped">
                            <tbody>
                                {
                                    fields.map((f, i) => {
                                        if (f.type === "selectcustom") {
                                            return <>
                                                <tr key={i + "Tr"} id={f.name + "Tr"}>
                                                    <td>
                                                        <label>
                                                            {`${f.label}`}  {f.required === undefined || f.required === true ? <span className="required">*</span> : <></>}
                                                        </label>
                                                    </td>
                                                    <td>
                                                        {f.name == "subSectionKPICompany" ?
                                                            <div style={{ width: '100%' }}>
                                                                <Select
                                                                    name={f.name}
                                                                    id={f.name}
                                                                    options={companiesOptions}
                                                                    value={multipleValues}
                                                                    isMulti
                                                                    placeholder="Select one or more companies..."
                                                                    closeMenuOnSelect={false}
                                                                    onChange={(a) => setMultipleValues(a)}
                                                                    styles={{ ...formSelectStyles, control: formSelectControlFullWidth }}
                                                                    classNamePrefix="form-select"
                                                                    menuPortalTarget={document.body}
                                                                    menuPosition="fixed"
                                                                />
                                                            </div>
                                                            :
                                                            <div style={{ width: '100%' }}>
                                                                <CreatableSelect
                                                                    name="customOptions"
                                                                    id="customOptions"
                                                                    isDisabled={disabledCustomSelect}
                                                                    components={{ DropdownIndicator: null }}
                                                                    isClearable={false}
                                                                    isMulti
                                                                    menuIsOpen={false}
                                                                    placeholder="Type something and press enter..."
                                                                    onChange={(e) => {
                                                                        setSelectCustomValue(e);
                                                                    }}
                                                                    onInputChange={(e) => setSelectCustomInput(e)}
                                                                    onKeyDown={(e) => {
                                                                        switch (e.key) {
                                                                            case 'Enter':
                                                                            case 'Tab':
                                                                                if (selectCustomInput == "")
                                                                                    return;
                                                                                var newData = {
                                                                                    "value": selectCustomInput,
                                                                                    "label": selectCustomInput
                                                                                }
                                                                                var newArray = [...selectCustomValue, newData];
                                                                                setSelectCustomInput("");
                                                                                setSelectCustomValue(newArray);
                                                                                var newCustomOptions = ""
                                                                                newArray.map((option, i) => {
                                                                                    if (i == newArray.length - 1) {
                                                                                        newCustomOptions += option.value
                                                                                    } else {
                                                                                        newCustomOptions += option.value + ";"
                                                                                    }
                                                                                })
                                                                                setCustomOptions(newCustomOptions)
                                                                                e.preventDefault();
                                                                        }
                                                                    }}
                                                                    value={selectCustomValue}
                                                                    inputValue={selectCustomInput}
                                                                    styles={{ ...formSelectStyles, control: formSelectControlFullWidth }}
                                                                    classNamePrefix="form-select"
                                                                />
                                                            </div>
                                                        }
                                                    </td>
                                                </tr>
                                            </>
                                        }
                                        else if (f.type === "select") {
                                            return <tr key={i + "Tr"} id={f.name + "Tr"}>
                                                <td width="25%">
                                                    <label>
                                                        {`${f.label}`}  {f.required === undefined || f.required === true ? <span className="required">*</span> : <></>}
                                                    </label>
                                                </td>
                                                <td width="75%">
                                                    {!f.multiple ?
                                                        <FormInput
                                                            name={f.name}
                                                            id={f.name}
                                                            checked={f.checked}
                                                            inputType={f.type}
                                                            placeholder={f.placeholder}
                                                            options={f.options}
                                                            disabled={f.disabled ? f.disabled : false}
                                                            value={data?.[f.name]}
                                                            onChange={(a) => {
                                                                if (data != null) {
                                                                    setData((prev) => (prev ? { ...prev, [f.name]: a.target.value } : prev));
                                                                }
                                                                if (f.name == "unitMeasureID" && a.target.value != 24 && a.target.value != 77) {
                                                                    let unit = unitMeasureList.find(e => e.unitMeasureID == a.target.value)
                                                                    let typeInput = GetTypeInput(unit.unitMeasureID, unit.type)
                                                                    let changed = SubSectionKPIConditionalfields
                                                                    changed[0].unitMeasure = typeInput
                                                                    setSubSectionKPIConditionalfields([...changed])
                                                                    setDisabledCustomSelect(true);
                                                                    setSelectCustomValue([]);
                                                                } else if (f.name == "unitMeasureID" && (a.target.value == 24 || a.target.value == 77)) {
                                                                    let unit = unitMeasureList.find(e => e.unitMeasureID == a.target.value)
                                                                    let typeInput = GetTypeInput(unit.unitMeasureID, unit.type)
                                                                    let changed = SubSectionKPIConditionalfields
                                                                    changed[0].unitMeasure = typeInput
                                                                    setSubSectionKPIConditionalfields([...changed])
                                                                    setDisabledCustomSelect(false);
                                                                    //setSelectCustomValue([]);
                                                                } else if (f.name != "unitMeasureID" && (data?.unitMeasureID == 24 || data?.unitMeasureID == 77)) {
                                                                    setDisabledCustomSelect(false);
                                                                } else {
                                                                    setDisabledCustomSelect(true);
                                                                }
                                                                if (f.onChanged != null) {
                                                                    f.onChanged(formRef.current, a);
                                                                }
                                                                return;
                                                            }}
                                                        />
                                                        :
                                                        <div style={{ width: '100%' }}>
                                                            <Select
                                                                options={f.options.map((o) => ({ value: o.value, label: o.text }))}
                                                                value={multipleValues}
                                                                isMulti
                                                                closeMenuOnSelect={false}
                                                                onChange={(a) => setMultipleValues(a)}
                                                                styles={{ ...formSelectStyles, control: formSelectControlFullWidth }}
                                                                classNamePrefix="form-select"
                                                                menuPortalTarget={document.body}
                                                                menuPosition="fixed"
                                                            />
                                                        </div>}
                                                </td>
                                            </tr>
                                        } else {
                                            if (id !== undefined && f.editable !== undefined && f.editable === false) {
                                                return <></>
                                            } else {
                                                return <tr key={i + "Tr"} id={f.name + "Tr"}>
                                                    <td width="25%">
                                                        <label>
                                                            {`${f.label}`}  {f.required === undefined || f.required === true ? <span className="required">*</span> : <></>}
                                                        </label>
                                                    </td>
                                                    <td width="75%">
                                                        <FormInput
                                                            className="form-control"
                                                            name={f.name}
                                                            id={f.name}
                                                            disabled={f.disabled ? f.disabled : false}
                                                            checked={f.checked}
                                                            value={data?.[f.name]}
                                                            inputType={f.type}
                                                            defaultValue={f.value ?? ""}
                                                            onChange={(a) => {
                                                                if (data != null && a?.target != null) {
                                                                    const v = f.type === 'check' ? a.target.checked : a.target.value;
                                                                    setData((prev) => (prev ? { ...prev, [f.name]: v } : prev));
                                                                }
                                                            }}
                                                        />
                                                    </td>
                                                </tr>
                                            }
                                        }
                                    })
                                }

                            </tbody>
                        </table>
                        <div className='mt-5'>
                            {

                                <a className="addnewLine btn-primary" style={{ padding: '0.5rem 1rem', textDecoration: 'none', cursor: 'pointer' }} onClick={() => {
                                    if (subSectionKPIsOptions && data?.subSectionKPIConditionalBlocks) {
                                        const blocks = [...data.subSectionKPIConditionalBlocks, { value: "", subSectionKPIIDs: "" }];
                                        setData({ ...data, subSectionKPIConditionalBlocks: blocks });
                                    }
                                }}>Add New Conditional Block</a>

                            }
                        </div>
                        <table className="table table-striped my-5">
                            <thead>
                                <tr><th scope="col">{"Index"}</th>
                                    {SubSectionKPIConditionalfields.map((cs) => {
                                        return (
                                            <th scope="col text-center">{cs.label}</th>
                                        )
                                    })}
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    data && data.subSectionKPIConditionalBlocks && data.subSectionKPIConditionalBlocks.length > 0 && subSectionKPIsOptions?.length > 0 ?
                                        data.subSectionKPIConditionalBlocks.filter(e => !e.isDeleted)?.map((col, colinx) => {
                                            return (
                                                <tr>
                                                    <td>
                                                        <label>
                                                            {colinx + 1}
                                                        </label>
                                                    </td>
                                                    {SubSectionKPIConditionalfields.map((c, ind) => {
                                                        return (
                                                            ind == 0 ? <td scope="row">
                                                                {

                                                                    <FormInput
                                                                        name={c.name}
                                                                        id={c.name + ind}
                                                                        autoComplete="off"
                                                                        value={col.value != null ? col.value : ""}
                                                                        //title={moduleObject.isEditable && value != null ? subSectionKPITarget.kpi.inputMessage : ""}
                                                                        inputType={"input"}
                                                                        //className={moduleObject.isEditable ? "" : "read-only"}
                                                                        //customOptions={subSectionKPITarget.kpi.customOptions}
                                                                        //placeholder={c.unitMeasure.inputType == "selectcustom" ? { value: "", text: "Select an option" } : null}
                                                                        //disabled={moduleObject.isEditable && country != null ? false : true}
                                                                        onChange={(f) => {
                                                                            setAnswersRules(f.target.value, colinx, "value")
                                                                        }
                                                                        }

                                                                    />
                                                                /* {
                                                                    c.unitMeasure && c.unitMeasure.inputType == 'selectfuel' ?

                                                                        <FormInput
                                                                            //options={fuelTypeOptions}
                                                                            name={c.name}
                                                                            id={c.name + ind}
                                                                            inputType={'input'}
                                                                            autoComplete="off"
                                                                            value={col.value != null ? col.value : ""}
                                                                            onChange={(f) => {
                                                                                setAnswersRules(f.target.value, colinx, "value")
                                                                            }}
                                                                        />

                                                                        :
                                                                        (c.unitMeasure && c.unitMeasure.inputType == 'selectcustom' && customOptions ?
                                                                            <FormInput
                                                                                customOptions={customOptions}
                                                                                name={c.name}
                                                                                id={c.name + ind}
                                                                                inputType={c.unitMeasure.inputType}
                                                                                autoComplete="off"
                                                                                value={col.value != null ? col.value : ""}
                                                                                onChange={(f) => {
                                                                                    setAnswersRules(f.target.value, colinx, "value")
                                                                                }}
                                                                            />
                                                                            :
                                                                            <FormInput
                                                                                name={c.name}
                                                                                id={c.name + ind}
                                                                                autoComplete="off"
                                                                                value={col.value != null ? col.value : ""}
                                                                                //title={moduleObject.isEditable && value != null ? subSectionKPITarget.kpi.inputMessage : ""}
                                                                                inputType={c.unitMeasure && c.unitMeasure.inputType != null && c.unitMeasure.inputType != "" ? c.unitMeasure.inputType : "text"}
                                                                                //className={moduleObject.isEditable ? "" : "read-only"}
                                                                                //customOptions={subSectionKPITarget.kpi.customOptions}
                                                                                //placeholder={c.unitMeasure.inputType == "selectcustom" ? { value: "", text: "Select an option" } : null}
                                                                                //disabled={moduleObject.isEditable && country != null ? false : true}
                                                                                onChange={(f) => {
                                                                                    setAnswersRules(f.target.value, colinx, "value")
                                                                                }
                                                                                }

                                                                            />
                                                                        )
                                                                } */}
                                                            </td>
                                                                :
                                                                <td style={{ width: "60rem" }}>
                                                                    <div style={{ width: '100%' }}>
                                                                        <Select
                                                                            options={c.options}
                                                                            value={col.subSectionKPIIDs}
                                                                            isMulti
                                                                            closeMenuOnSelect={false}
                                                                            onChange={(a) => setAnswersRules(a, colinx, "subSectionKPIIDs")}
                                                                            styles={{ ...formSelectStyles, control: formSelectControlFullWidth }}
                                                                            classNamePrefix="form-select"
                                                                            menuPortalTarget={document.body}
                                                                            menuPosition="fixed"
                                                                        />
                                                                    </div>
                                                                </td>
                                                        )
                                                    })}
                                                    {colinx != 0 ? <td><AiOutlineDelete size={20} onClick={(e) => { removeRule(colinx) }/*handleRemoveColumnRowInputs(e.target.value, colinx)*/} /></td> : <></>}
                                                </tr>
                                            )
                                        })

                                        : <></>
                                }
                            </tbody>
                        </table>
                        <div className="d-flex flex-row mt-2">
                            <CancelButton />
                            <Button type="submit">Save</Button>
                        </div>
                    </Form>
                </div>
            </Container>
            : <></>
    );
}

export default SubSectionKPIEdit;
